export default __webpack_public_path__ + "static/media/key-plant.bb9dcfe0.svg";